<script>
  export let editor;
  export let onRemove;
  export let last;

  import { dictionary } from "../utils/stores.js";

  import { onMount } from "svelte";

  let dict;

  const unsubscribe = dictionary.subscribe(value => {
    dict = value;
  });

  let fechaRespuesta = "";
  let respuestaIcon = "";
  let respuestaTitle = "";

  onMount(() => {
    fechaRespuesta =
      editor.aceptado === ""
        ? "-"
        : moment(editor.fechaAceptado).format("DD MMMM YYYY HH:mm:ss");
    switch (editor.aceptado) {
      case "Si":
        respuestaIcon = "/images/revista/revisor-accept.svg";
        respuestaTitle = dict["decisionEditorOk"];
        break;
      case "No":
        respuestaIcon = "/images/revista/revisor-reject.svg";
        respuestaTitle = dict["decisionEditorNoOk"];
        break;
      default:
        respuestaIcon = "/images/revista/clock.svg";
        respuestaTitle = dict["decisionEditor"];
        break;
    }
  });
</script>

<style>
  div.articleEditorItem {
    display: flex;
    width: 100%;
    color: var(--revista-black) !important;
    padding-top: 10px;
    padding-bottom: 10px;
    border-top-color: lightgray;
    border-top-width: 1px;
    border-top-style: solid;
    justify-content: space-between;
    align-items: center;
  }

  div.last {
    border-bottom-color: lightgray;
    border-bottom-width: 1px;
    border-bottom-style: solid;
  }

  div.icon {
    margin-right: 20px;
  }

  div.icon img {
    width: 25px;
    height: 25px;
  }

  div.info {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
  }

  div.options {
    display: flex;
  }

  div.options img {
    width: 20px;
    height: 20px;
    margin-left: 5px;
  }

  img.imgButton {
    cursor: pointer;
  }
</style>

<div class="articleEditorItem {last ? 'last' : ''}">
  <div class="icon">
    <img class="user" src="/images/revista/user-e.svg" alt="User Icon" />
  </div>
  <div class="info">
    {editor.nombreUsuario + ' ' + editor.apellido1Usuario + ' ' + editor.apellido2Usuario}
  </div>
  <div class="options">
    <img title={respuestaTitle} src={respuestaIcon} alt="Pending Icon" />
    <img
      class="imgButton"
      src="/images/revista/close.svg"
      alt="Remove Icon"
      on:click={onRemove} />
  </div>
</div>
